export default __webpack_public_path__ + "static/lxl-cancer-8e22e986ac7840b2b779e07d9299430a.webp";